var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.631,
    height: 15.029,
    viewBox: "0 0 13.631 15.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M13.259,1.25H7.667A2.622,2.622,0,0,0,5.046,3.871v.175H4.871A2.622,2.622,0,0,0,2.25,6.667v6.99a2.622,2.622,0,0,0,2.621,2.621h5.592a2.622,2.622,0,0,0,2.621-2.621v-.175h.175a2.622,2.622,0,0,0,2.621-2.621V3.871A2.622,2.622,0,0,0,13.259,1.25ZM12.036,13.658a1.575,1.575,0,0,1-1.573,1.573H4.871A1.575,1.575,0,0,1,3.3,13.658V6.667A1.575,1.575,0,0,1,4.871,5.095h5.592a1.575,1.575,0,0,1,1.573,1.573Zm2.8-2.8a1.575,1.575,0,0,1-1.573,1.573h-.175V6.667a2.622,2.622,0,0,0-2.621-2.621H6.095V3.871A1.575,1.575,0,0,1,7.667,2.3h5.592a1.575,1.575,0,0,1,1.573,1.573Zm-4.544-.7a.528.528,0,0,1-.524.524H5.57a.524.524,0,0,1,0-1.049H9.764A.528.528,0,0,1,10.289,10.162Zm0-2.8a.528.528,0,0,1-.524.524H5.57a.524.524,0,0,1,0-1.049H9.764A.528.528,0,0,1,10.289,7.366Zm0,5.592a.528.528,0,0,1-.524.524H5.57a.524.524,0,0,1,0-1.049H9.764A.528.528,0,0,1,10.289,12.958Z",
    transform: "translate(-2.25 -1.25)",
    fill: "#8d8d8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.c45a9e4e336bfba20ce89498b9265b82.svg";
export { ForwardRef as ReactComponent };